import axiosInstance from './config/api';

type Agent = {
    name: string;
    status: string;
    calls_taken_today: number;
    id: string;
};

export type ManagerCenterDataParams = {
    startDate: Date;
    endDate: Date;
};

type ManagerCenterData = {
    metrics: {
        calls_taken: number;
        online_agents: number;
    };
    agents: Agent[];
};

export const getManagerCenterData = async (params: ManagerCenterDataParams) => {
    return await axiosInstance
        .get<ManagerCenterData>('/manager-command-center/dashboard', { params })
        .then((res) => res.data);
};
